export const SET_KEYS = "SET_KEYS";

export interface SettingsPanelState {
  setSettingsPanelActiveKeys: string[];
}

interface SettingsPanelSetActiveKeysAction {
  type: typeof SET_KEYS;
  meta: {
    params: {
      setSettingsPanelActiveKeys: string[];
    };
  };
}

export type SettingsPanelActionTypes = SettingsPanelSetActiveKeysAction;
